import './sass/frontend.scss';

function maybe_update_slider_height() {
    if (jQuery('.header_scroller .overlay').length > 0) {
        var image_height = jQuery('.header_scroller .overlay img').height();

        jQuery('.header_scroller .kb-advanced-slide').height(image_height);

    }

}
jQuery(window).resize(function () {
    // Check if the .overlay div exists
    if (jQuery('.header_scroller .overlay').length > 0) {
        maybe_update_slider_height();
    }
});

jQuery(document).ready(function () {
    // Check if the .overlay div exists
    if (jQuery('.header_scroller .overlay').length > 0) {
        maybe_update_slider_height();
    }
});